import { evaluate, equal, parse, derivative } from "mathjs";

export const isAntiderivada = (str: string) => {

    const arreglo = [];

    try {
        for (var i = 1; i < 10+1; i++) {
            for (let k = 0; k < 10+1; k++) {
                arreglo.push(isNaN(evaluate(str,{X:i/10, C:k/10})));
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una antiderivada general'
        }
    }
 
    const long = arreglo.filter(Boolean).length;

    if (long !== 0) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: `${str} no es una fórmula en x y C`
        }
    }

    try {

        const array = [];

        const f = parse(str)
        const C = parse('C')
        const derivada = derivative(f, C)
        
        for (var i = 1; i < 10+1; i++) {
            array.push(derivada.evaluate({C: i}));
        }

        const allEquals = array.every( v => v === derivada.evaluate({C: 1}));

        if (allEquals && derivada.evaluate({C:1}) !== 0) {
            return { 
                ok: true, 
                title: 'Exito',
                msg: `${str} es una antiderivada`
            }
        } else {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'Tu respuesta no representa una antiderivada'
            }
        }
        
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una antiderivada'
        }
    }


}



export const equalAntiderivadas = (formulaDataBase: string, numberUser: string) => {

    const arreglo = [];

    const f = parse(formulaDataBase)
    const g = parse(numberUser)
    const X = parse('X')
    const Df = derivative(f, X)
    const Dg = derivative(g, X)

    try {
        for (var i = 1; i < 10+1; i++) {
            arreglo.push(equal(Df.evaluate({X:i/10}),Dg.evaluate({X:i/10})))
        }
    } catch (error) {
        return { 
            ok: true, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una antiderivada'
        }
    }

    const long = arreglo.filter(Boolean).length

    if (long === 10) {
        return { 
            ok: true, 
            title: '¡Felicitaciones!',
            msg: 'Has encontrado la solución'
        }
    } else {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la altiderivada solución'
        }
    }
}